/** @jsxImportSource @emotion/react */
import React from 'react'
import {QuestionsForm, QuestionsPreview} from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/QuestionsContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, manageQuestions } = breadcrumbItems

const ManageNews: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, manageQuestions]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <QuestionsForm />
        </div>
        <div css={styles.right}>
          <QuestionsPreview />
        </div>
      </div>
    </Provider>
  )
}

export default ManageNews
